import { render, staticRenderFns } from "./ShowCustomMappingComponent.vue?vue&type=template&id=53ce7936&scoped=true&"
import script from "./ShowCustomMappingComponent.ts?vue&type=script&lang=js&"
export * from "./ShowCustomMappingComponent.ts?vue&type=script&lang=js&"
import style0 from "./ShowCustomMappingComponent.vue?vue&type=style&index=0&id=53ce7936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce7936",
  null
  
)

export default component.exports